module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/fraternity-3-medium-516fbbce09808bd6e711bf3c6ef09c63.jpg";